<a>
  <span ng-bind-html="match.model.number | uibTypeaheadHighlight:query"></span>
  <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span>
</a>
